'use client';

import { ManifestInputField, ManifestSelectField } from '../fields';
import { ManifestSection } from '../ManifestSection';
import { mapManifestOptionsToHtmlOptions } from '../utils';

import type { AnyFieldApi } from '@tanstack/react-form';
import type { SimpleFormApi } from '@lib/form/helper';
import type { Manifest, ManifestFormValues } from '../types';
import type { I18NInterface } from '@tuic/web-compositions/utils/i18n';
import type { FC } from 'react';

export type PersonalInfoSectionProps = {
  form: SimpleFormApi<ManifestFormValues>;
  manifest?: Manifest;
  disabled?: boolean;

  i18n?: I18NInterface<
    | 'personalInfoTitle'
    | 'personalInfoFieldTitle'
    | 'personalInfoSalutation'
    | 'personalInfoFirstName'
    | 'personalInfoFirstNameNote'
    | 'personalInfoLastName'
    | 'personalInfoLastNameNote'
    | 'personalInfoSelectPlaceholder'
  >;
};

export const PersonalInfoSection: FC<PersonalInfoSectionProps> = ({
  form,
  i18n,
  manifest,
  disabled,
}) => {
  const options = manifest?.manifestOptions?.personalInfo;

  return (
    <ManifestSection
      pictogram="human-profile"
      headline={i18n?.personalInfoTitle}
    >
      <div className="flex flex-col gap-4 md:flex-row md:gap-8">
        <form.Field name="personalInfo.salutation">
          {(field: AnyFieldApi) => (
            <ManifestSelectField
              field={field}
              className="w-full"
              label={i18n?.personalInfoSalutation}
              options={mapManifestOptionsToHtmlOptions(options?.salutationOptions)}
              disabled
            />
          )}
        </form.Field>
        <form.Field name="personalInfo.title">
          {(field: AnyFieldApi) => (
            <ManifestSelectField
              field={field}
              className="w-full"
              label={i18n?.personalInfoFieldTitle}
              options={mapManifestOptionsToHtmlOptions(options?.titleOptions)}
              placeholder={i18n?.personalInfoSelectPlaceholder}
              clearable
              disabled={disabled}
            />
          )}
        </form.Field>
      </div>
      <div className="flex flex-col gap-4 md:flex-row md:gap-8">
        <form.Field name="personalInfo.firstName">
          {(field: AnyFieldApi) => (
            <ManifestInputField
              field={field}
              label={i18n?.personalInfoFirstName}
              note={i18n?.personalInfoFirstNameNote}
              disabled
              className="w-full"
            />
          )}
        </form.Field>
        <form.Field name="personalInfo.lastName">
          {(field: AnyFieldApi) => (
            <ManifestInputField
              field={field}
              label={i18n?.personalInfoLastName}
              note={i18n?.personalInfoLastNameNote}
              disabled
              className="w-full"
            />
          )}
        </form.Field>
      </div>
    </ManifestSection>
  );
};
